export enum TabNames {
  Roles = 'Roles',
  VisibilityGroups = 'Visibility Groups',
  OnlineLeads = 'Online Leads',
  OwnerUnassignedEntities = 'Owner Unassigned Entities',
}
